import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import LoginView from 'views/Auth/LoginView';

const UnauthenticatedRoutes = () => {
  return (
    <Routes>
      <Route path="/login" element={<LoginView />} />
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
};

export default UnauthenticatedRoutes;
